import React, { createContext, useState } from 'react';

// Create a context
export const MyContext = createContext();

export const MyTenantsPageContext = ({ children }) => {
  const [sharedValue, setSharedValue] = useState('Overview');
  const [activeItem, setActiveItem] = useState("Overview"); // State to keep track of the active item


   //current date
  const date = new Date(Date.now());
  
   // Get the full year
  const curerntYear = date.getFullYear();
  
  //get day
  const day = date.getDate();
 
   // Get the month index (0-11), and convert to full month name
   const monthNames = [
     "January",
     "February",
     "March",
     "April",
     "May",
     "June",
     "July",
     "August",
     "September",
     "October",
     "November",
     "December",
   ];
   const currentMonth = monthNames[date.getMonth()];
 
   const [selectedDate, setSelectedDate] = useState({
     month: `${currentMonth}`,
     year: curerntYear,
     day: day,
   });
  
  const [rolesAssigned, setRolesAssigned ]= useState({
    manageProperties: false,
    manageTenants: false,
    makePayments: false,
    approvePayments: false,
    viewReports: false,
    createRentInvoice: false,
  });

  const [currentProperty, setCurrentProperty] = useState(null);


  return (
    <MyContext.Provider value={{ sharedValue, setSharedValue,activeItem,setActiveItem,curerntYear,currentMonth, monthNames,selectedDate,setSelectedDate,rolesAssigned,setRolesAssigned,currentProperty,setCurrentProperty }}>
      {children}
    </MyContext.Provider>
  );
};
